export default "__VITE_ASSET__DmFEWN5H__"